import type { FlagEvaluationOptions } from '@openfeature/web-sdk';
import { getFlag as getOpenFeatureFlag } from '../../../openfeature/client';
import type { FlagKey, FlagValue } from '../types';
import { getConfidenceOverrides } from '../development-tools/ConfidenceOverridesProvider';
import {
  coerceFlagValue,
  isSupportedFlagType,
} from '../development-tools/utils';

export function getFlag<K extends FlagKey>(
  key: K,
  defaultFlagValue: FlagValue<K>,
  options?: FlagEvaluationOptions,
) {
  const overrides = getConfidenceOverrides();
  const flagValueType = typeof defaultFlagValue;

  if (key in overrides) {
    const confidenceOverride = overrides[key];

    if (!isSupportedFlagType(flagValueType)) {
      throw new Error(`Unsupported flag type: ${flagValueType}`);
    }

    return {
      value: coerceFlagValue(confidenceOverride, flagValueType) as FlagValue<K>,
    };
  }

  const result = getOpenFeatureFlag(key, defaultFlagValue, options);

  return { value: result.value };
}
